import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  selectUnbindTxSelf,
  TransactionLoading,
} from '../../../../store/web3/unbind.side-effects'
import { TxBroadcastedModal } from './TxBroadcastedModal'
import { TxFailedModal } from './TxFailedModal'
import { TxPendingConfirmModal } from './TxPendingConfirmModal'

export const TxModal: React.FC = () => {
  const { loading, hash } = useSelector(selectUnbindTxSelf)
  const hidden = loading === TransactionLoading.IDLE
  useEffect(() => {
    return () => {
      if (document.body.style.overflow === 'hidden') {
        document.body.style.overflow = 'auto'
      }
    }
  }, [hidden])

  switch (loading) {
    case TransactionLoading.PENDING:
      return <TxPendingConfirmModal />
    case TransactionLoading.MINED:
    case TransactionLoading.BROADCASTED:
      return (
        <TxBroadcastedModal
          txHash={hash}
          isMined={loading === TransactionLoading.MINED}
        />
      )
    case TransactionLoading.ERROR:
      return <TxFailedModal />
    case TransactionLoading.IDLE:
      return null
  }
}
